import type { IRouteSchedule } from "@ryde/shared";

/** The course upload reads these separators back, so a change here must be matched in the backend upload transformers. */
export const COURSE_CSV_SEPARATORS = {
  station: "\n",
  scheduleEntry: " | ",
} as const;

export interface ICourseScheduleCsvParams {
  schedules: IRouteSchedule[] | null | undefined;
  dayTypeNameById: Map<number, string>;
  dayGroupNameById: Map<number, string>;
  dayTypeLabel: string;
  dayGroupLabel: string;
}
